import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import { ResumeData } from '@/stores/resumeStore';
interface MasterPanelProps {
  isOpen: boolean;
  onClose: () => void;
  position: {
    x: number;
    y: number;
  } | null;
  selectedText: string;
  onApplyFormat: (format: 'bold' | 'italic' | 'link', url?: string) => void;
  resumeDesign: ResumeData['design'];
  onUpdateDesign: (field: string, value: any) => void;
  isDarkMode: boolean;
}
const MasterPanel: React.FC<MasterPanelProps> = t0 => {
  const $ = _c(47);
  const {
    isOpen,
    onClose,
    position,
    selectedText,
    onApplyFormat,
    resumeDesign,
    onUpdateDesign,
    isDarkMode
  } = t0;
  const [activeTab, setActiveTab] = useState("format");
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setLinkUrl("");
        setShowLinkInput(false);
        setActiveTab("format");
      }
    };
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isOpen || $[3] !== selectedText) {
    t2 = [isOpen, selectedText];
    $[2] = isOpen;
    $[3] = selectedText;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  let t3;
  if ($[5] !== position) {
    t3 = isMobile ? {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      width: "100%",
      zIndex: 1001,
      transform: "none",
      borderRadius: "12px 12px 0 0"
    } : position ? {
      position: "fixed",
      left: `${Math.min(position.x, window.innerWidth - 340)}px`,
      top: `${position.y + 20}px`,
      zIndex: 1000
    } : {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1000
    };
    $[5] = position;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const panelStyle = t3;
  const handleMouseDown = _temp;
  const getNumericValue = _temp2;
  let t4;
  if ($[7] !== onUpdateDesign) {
    t4 = (field, rawValue, unit) => {
      const clean = rawValue.replace(/[^0-9.]/g, "");
      if (clean) {
        onUpdateDesign(field, `${clean}${unit}`);
      } else {
        onUpdateDesign(field, "");
      }
    };
    $[7] = onUpdateDesign;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleUnitUpdate = t4;
  const t5 = `shadow-2xl border flex flex-col overflow-hidden animate-in fade-in slide-in-from-bottom-10 duration-200 
                md:w-80 md:rounded-xl md:zoom-in-95
                ${isDarkMode ? "bg-slate-800 border-white/10 text-white" : "bg-white border-slate-200 text-slate-800"}`;
  const t6 = `flex border-b ${isDarkMode ? "border-white/10" : "border-slate-100"}`;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setActiveTab("format");
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `flex-1 py-2 text-xs font-semibold uppercase tracking-wider transition-colors ${activeTab === "format" ? "bg-purple-500/10 text-purple-500 border-b-2 border-purple-500" : "text-slate-500 hover:text-slate-400"}`;
  let t9;
  if ($[10] !== t8) {
    t9 = <button onClick={t7} className={t8}>Text Format</button>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setActiveTab("design");
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = `flex-1 py-2 text-xs font-semibold uppercase tracking-wider transition-colors ${activeTab === "design" ? "bg-purple-500/10 text-purple-500 border-b-2 border-purple-500" : "text-slate-500 hover:text-slate-400"}`;
  let t12;
  if ($[13] !== t11) {
    t12 = <button onClick={t10} className={t11}>Design Settings</button>;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = `px-3 hover:bg-red-500/10 hover:text-red-500 transition-colors ${isDarkMode ? "text-slate-500" : "text-slate-400"}`;
  let t14;
  if ($[15] !== onClose || $[16] !== t13) {
    t14 = <button onClick={onClose} className={t13}>✕</button>;
    $[15] = onClose;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t12 || $[19] !== t14 || $[20] !== t6 || $[21] !== t9) {
    t15 = <div className={t6}>{t9}{t12}{t14}</div>;
    $[18] = t12;
    $[19] = t14;
    $[20] = t6;
    $[21] = t9;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== activeTab || $[24] !== isDarkMode || $[25] !== linkUrl || $[26] !== onApplyFormat || $[27] !== selectedText || $[28] !== showLinkInput) {
    t16 = activeTab === "format" && <div className="space-y-4">{!showLinkInput ? <><div className="flex gap-2 justify-center"><button onClick={() => onApplyFormat("bold")} className={`p-2 rounded hover:bg-purple-500/20 transition-colors font-bold border ${isDarkMode ? "border-white/10" : "border-slate-200"}`} title="Bold (Ctrl+B)">B</button><button onClick={() => onApplyFormat("italic")} className={`p-2 rounded hover:bg-purple-500/20 transition-colors italic border ${isDarkMode ? "border-white/10" : "border-slate-200"}`} title="Italic (Ctrl+I)">I</button><button onClick={() => setShowLinkInput(true)} className={`p-2 rounded hover:bg-purple-500/20 transition-colors underline border ${isDarkMode ? "border-white/10" : "border-slate-200"}`} title="Link">🔗</button></div><div className={`text-xs p-2 rounded ${isDarkMode ? "bg-white/5" : "bg-slate-50"} text-center opacity-70`}>{selectedText ? `Selected: "${selectedText.substring(0, 20)}${selectedText.length > 20 ? "..." : ""}"` : "Select text to format"}</div></> : <div className="space-y-2 animate-in slide-in-from-right duration-200"><label className="text-xs font-medium block">Enter URL for: "{selectedText.substring(0, 15)}..."</label><div className="flex gap-2"><input type="text" value={linkUrl} onChange={e_0 => setLinkUrl(e_0.target.value)} placeholder="https://example.com" className={`flex-1 px-2 py-1.5 rounded text-sm border ${isDarkMode ? "bg-white/5 border-white/10" : "bg-slate-50 border-slate-200"}`} autoFocus={true} onKeyDown={e_1 => {
            if (e_1.key === "Enter") {
              onApplyFormat("link", linkUrl);
            }
            if (e_1.key === "Escape") {
              setShowLinkInput(false);
            }
          }} /><button onClick={() => onApplyFormat("link", linkUrl)} className="px-3 py-1 bg-purple-500 text-white rounded text-sm hover:bg-purple-600">Add</button></div><button onClick={() => setShowLinkInput(false)} className="text-xs text-slate-500 hover:text-slate-400">Cancel</button></div>}</div>;
    $[23] = activeTab;
    $[24] = isDarkMode;
    $[25] = linkUrl;
    $[26] = onApplyFormat;
    $[27] = selectedText;
    $[28] = showLinkInput;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== activeTab || $[31] !== handleUnitUpdate || $[32] !== isDarkMode || $[33] !== onUpdateDesign || $[34] !== resumeDesign) {
    t17 = activeTab === "design" && <div className="space-y-4"><div><label className="text-xs font-medium opacity-70 mb-1 block">Body Font Size (pt)</label><div className="flex items-center gap-2"><input type="text" value={getNumericValue(resumeDesign.typography?.font_size?.body)} onChange={e_2 => handleUnitUpdate("typography.font_size.body", e_2.target.value, "pt")} className={`w-full px-2 py-1 rounded text-sm border ${isDarkMode ? "bg-white/5 border-white/10" : "bg-slate-50 border-slate-200"}`} placeholder="10" /><span className="text-xs opacity-50">pt</span></div></div><div><label className="text-xs font-medium opacity-70 mb-1 block">Line Spacing (cm)</label><div className="flex items-center gap-2"><input type="text" value={getNumericValue(resumeDesign.typography?.line_spacing)} onChange={e_3 => handleUnitUpdate("typography.line_spacing", e_3.target.value, "cm")} className={`w-full px-2 py-1 rounded text-sm border ${isDarkMode ? "bg-white/5 border-white/10" : "bg-slate-50 border-slate-200"}`} placeholder="0.5" /><span className="text-xs opacity-50">cm</span></div></div><div className="h-px bg-slate-200/50 dark:bg-slate-700/50 my-2" /><div><label className="text-xs font-medium opacity-70 mb-1 block">Header Color</label><input type="text" value={resumeDesign.colors?.name || ""} onChange={e_4 => onUpdateDesign("colors.name", e_4.target.value)} className={`w-full px-2 py-1 rounded text-sm border ${isDarkMode ? "bg-white/5 border-white/10" : "bg-slate-50 border-slate-200"}`} placeholder="rgb(0,0,0)" /></div><div><label className="text-xs font-medium opacity-70 mb-1 block">Section Title Color</label><input type="text" value={resumeDesign.colors?.section_titles || ""} onChange={e_5 => onUpdateDesign("colors.section_titles", e_5.target.value)} className={`w-full px-2 py-1 rounded text-sm border ${isDarkMode ? "bg-white/5 border-white/10" : "bg-slate-50 border-slate-200"}`} placeholder="rgb(0,0,0)" /></div></div>;
    $[30] = activeTab;
    $[31] = handleUnitUpdate;
    $[32] = isDarkMode;
    $[33] = onUpdateDesign;
    $[34] = resumeDesign;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17) {
    t18 = <div className="p-4 overflow-y-auto max-h-[400px]">{t16}{t17}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const t19 = `px-4 py-2 text-[10px] text-center ${isDarkMode ? "bg-white/5 text-slate-400" : "bg-slate-50 text-slate-500"}`;
  let t20;
  if ($[39] !== t19) {
    t20 = <div className={t19}>Values update RenderCV settings instantly</div>;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== panelStyle || $[42] !== t15 || $[43] !== t18 || $[44] !== t20 || $[45] !== t5) {
    t21 = <div style={panelStyle} onMouseDown={handleMouseDown} className={t5}>{t15}{t18}{t20}</div>;
    $[41] = panelStyle;
    $[42] = t15;
    $[43] = t18;
    $[44] = t20;
    $[45] = t5;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  return t21;
};
export default MasterPanel;
function _temp(e) {
  e.stopPropagation();
}
function _temp2(val) {
  if (!val) {
    return "";
  }
  return String(val).replace(/[a-z%]+$/, "");
}